import isEqual from 'react-fast-compare';
import { handleActions } from 'redux-actions';
import { logoutSuccess } from 'ducks/auth/actions';

import { tourLogReportSuccess, tourLogSuccess } from './actions';

import initialState from './states';

export default handleActions(
  {
    [tourLogSuccess](state, { payload }) {
      if (isEqual(state.info[payload.tourLogID], payload)) {
        return state;
      }
      return {
        ...state,
        info: {
          ...state.info,
          [payload.tourLogID]: Object.freeze(payload),
        },
      };
    },
    [tourLogReportSuccess](state, { payload: { tourLogID, link } }) {
      return {
        ...state,
        reportLinks: {
          ...state.reportLinks,
          [tourLogID]: link,
        },
      };
    },
    [logoutSuccess]() {
      return initialState;
    },
  },
  initialState
);
